import { useEffect, useState } from 'react';
import { subscription as subscriptionApi } from '@afosto/iam/api/Subscription';
import { useAppState, useAppActions } from '@afosto/app-components-react/AppProvider';

export const fetchSubscriptions = async (active = true) => {
  try {
    const response = await subscriptionApi.listSubscriptions();
    const formattedSubscriptions = response.data;

    if (active) {
      return formattedSubscriptions.filter(subscription => {
        const subscriptionEnd = new Date(subscription.end_at);
        const now = new Date();
        return subscriptionEnd.getTime() > now.getTime();
      });
    }

    return formattedSubscriptions;
  } catch (err) {
    return [];
  }
};

export default (active = true) => {
  const state = useAppState();
  const [actions] = useAppActions();
  const [subscriptions, setSubscriptions] = useState([]);
  const { setShouldRefreshSubscriptions } = actions || {};

  useEffect(() => {
    let isMounted = true;

    const handleFetchSubscriptions = async () => {
      try {
        const availableSubscriptions = await fetchSubscriptions(active);

        if (isMounted) {
          setSubscriptions(availableSubscriptions);
        }
      } catch (err) {
        if (isMounted) {
          setSubscriptions([]);
        }
      }
    };

    handleFetchSubscriptions();

    return () => {
      isMounted = false;
    };
  }, [active]);

  useEffect(() => {
    let isMounted = true;

    const refreshSubscriptions = async () => {
      try {
        const availableSubscriptions = await fetchSubscriptions();

        if (isMounted) {
          setSubscriptions(availableSubscriptions);
          setShouldRefreshSubscriptions(false);
        }
      } catch (err) {
        if (isMounted) {
          setSubscriptions([]);
          setShouldRefreshSubscriptions(false);
        }
      }
    };

    if (state.shouldRefreshSubscriptions) {
      refreshSubscriptions();
    }

    return () => {
      isMounted = false;
    };
  }, [state.shouldRefreshSubscriptions, setShouldRefreshSubscriptions]);

  return subscriptions;
};
